<template>
    <div class="filter-box">
        <div 
            class="left-box"
            ref="leftBox"
        >
            <van-sidebar 
                v-model="activeKey"  
                @change="onChange"
            >
                <van-sidebar-item 
                    title="住宿类型" />
                <van-sidebar-item 
                    title="酒店品牌" />
                <van-sidebar-item 
                    title="服务设施" />
            </van-sidebar>
        </div>
        <div 
            class="right-box"
            v-if="activeKey==0"
            ref="rightBox"
        >
            <h3>住宿类型</h3>
            <div class="btn-group">
                <div 
                    class="btn"
                    :class="hotel_type.includes(item)&&'active'"
                    v-for="(item,index) of typeList"
                    :key="index"
                    @click="chooseType(item)"
                >
                    {{item.value}}
                </div>
            </div>
        </div>
        <div 
            class="right-box"
            v-if="activeKey==1"
            ref="rightBox"
        >
            <h3>酒店品牌</h3>
            <div 
                class="btns"
                :class="classify.includes(item.id)&&'active'"
                v-for="(item,index) of typeList"
                :key="index"
            >   
                <div 
                    class="btns-nav"
                    @click="openBrandList(item.id)"
                >
                    <span>{{item.value}}</span>
                    <img src="@/assets/hotel/img/micon/show.png" alt="">
                </div>
                <div class="btn-group">
                    <div 
                        class="btn"
                        :class="hotel_classify.includes(mitem)&&'active'"
                        v-for="(mitem,mindex) of item.params"
                        :key="mindex"
                        @click="chooseBrand(mitem)"
                    >
                        {{mitem.value}}
                    </div>
                </div>
            </div>
            
        </div>
        <div 
            class="right-box"
            v-if="activeKey==2"
            ref="rightBox"
        >
            <h3>服务设施</h3>
            <div class="btn-group">
                <div 
                    class="btn"
                    :class="facilities.includes(item)&&'active'"
                    v-for="(item,index) of typeList"
                    :key="index"
                    @click="chooseServe(item)"
                >
                    {{item}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'
    export default {
        props:{
            setData:{//预设数据
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                activeKey: 0,//侧边栏下标
                typeList:[],//选中的筛选数据
                hotel_type:[],//酒店类型
                hotel_classify:[],//酒店品牌
                classify:[],//酒店品牌折叠
                facilities:[],//酒店设施
            }
        },
        computed:{
            ...mapState({
                filterActive: state => state.hotel.filterActive,
            })
        },
        mounted() {
            if(this.filterActive.length){
                this.hotel_type = this.filterActive[0];
                this.hotel_classify = this.filterActive[1];
                this.facilities = this.filterActive[2]
            }
        },
        methods: {
            ...mapMutations(['setState']),
            onChange(index) {//侧边栏切换
                switch(index){
                    case 0:
                        this.typeList = this.setData.hotel_type;
                        break;
                    case 1:
                        this.typeList = this.setData.hotel_classify;
                        break;
                    case 2:
                        this.typeList = this.setData.facilities;
                        break;
                }
                // this.$refs.rightBox[index].scrollTop=0;
            },
            init(){//初始化
                this.activeKey = 0;
                this.typeList = this.setData.hotel_type;
                if(this.filterActive&&this.filterActive[0]){
                    this.hotel_type = this.filterActive[0];
                    this.hotel_classify = this.filterActive[1];
                    this.facilities = this.filterActive[2];
                }
            },
            chooseType(item){//选择酒店类型
                if(this.hotel_type.includes(item)){
                    let index = this.hotel_type.indexOf(item);
                    this.hotel_type.splice(index,1);
                }else{
                    this.hotel_type.push(item);
                }
            },
            chooseBrand(item){//选择酒店品牌
                if(this.hotel_classify.includes(item)){
                    let index = this.hotel_classify.indexOf(item);
                    this.hotel_classify.splice(index,1);
                }else{
                    this.hotel_classify.push(item);
                }
            },
            openBrandList(idx){//打开酒店品牌扩展
                if(this.classify.includes(idx)){
                    let index = this.classify.indexOf(idx);
                    this.classify.splice(index,1);
                }else{
                    this.classify.push(idx);
                }
            },
            chooseServe(item){//选择酒店设施服务
                if(this.facilities.includes(item)){
                    let index = this.facilities.indexOf(item);
                    this.facilities.splice(index,1);
                }else{
                    this.facilities.push(item);
                }
            },
            confirm(){//确认
                this.setState([{name:'filterActive',value:[this.hotel_type,this.hotel_classify,this.facilities]}]);
                let name = '',num=0;
                if(this.hotel_type.length){
                    if(this.hotel_type.length>1){
                        name = `筛选·${this.hotel_type.length}`;
                        num = this.hotel_type.length;
                    }else{
                        name = this.hotel_type[0].value;
                        num = 1;
                    }
                }
                if(this.hotel_classify.length){
                    if(num>0){
                        name = `筛选·${num+this.hotel_classify.length}`;
                        num += this.hotel_classify.length;
                    }else{
                        if(this.hotel_classify.length>1){
                            name = `筛选·${this.hotel_classify.length}`;
                        }else{
                            name = this.hotel_classify[0].value;
                        }
                        num = this.hotel_classify.length;
                    }
                }
                if(this.facilities.length){
                    if(num>0){
                        name = `筛选·${num+this.facilities.length}`;
                        num += this.facilities.length;
                    }else{
                        if(this.facilities.length>1){
                            name = `筛选·${this.facilities.length}`;
                        }else{
                            name = this.facilities[0];
                        }
                        num = this.facilities.length;
                    }
                }
                return {name:name,value:[this.hotel_type,this.hotel_classify,this.facilities]};
            },
            reset(){//重置
                this.activeKey = 0;
                this.hotel_type = [];
                this.hotel_classify = [];
                this.classify = [];
                this.facilities = [];
                this.setState([{name:'filterActive',value:[]}]);
            }
        },
        watch:{
            setData(){
                this.init();
            }
        }
    }
</script>

<style lang="less" scoped>
    .filter-box{
        display: flex;
        .left-box{
            width: 9.5rem;
            background-color: #F4F9F6;
            .van-sidebar{
                width: 100%;
                .van-sidebar-item{
                    padding: 3rem 0 3rem 2rem;
                    background-color: #F4F9F6;
                    font-size: 1.5rem;
                    font-weight: 400;
                    color: #666666;
                    line-height: 2.1rem;
                }
                .van-sidebar-item--select{
                    font-weight: 500;
                    color: #108B30;
                    background-color: #fff;
                    &::before{
                        display: none;
                    }
                }
            }
        }
        .right-box{
            flex: 1;
            height: 37rem;
            padding: 0.5rem 0;
            box-sizing: border-box;
            overflow-y: scroll;
            padding: 3rem 0 2rem 1rem;
            h3{
                color: #333;
                font-size: 1.5rem;
                font-weight: 400;
                line-height: 2.1rem;
                padding-bottom: 1rem;
                margin: 0;
            }
            .btns{
                height: 13.3rem;
                overflow: hidden;
                transition: 1s ease-in-out;
                .btns-nav{
                    margin: 1rem 0;
                    font-size: 1.4rem;
                    color: #666666;
                    font-weight: 400;
                    line-height: 2rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-right: 2rem;
                    img{
                        width: 1.2rem;
                        height: 1.2rem;
                        transform-origin: center;
                        transform:rotateZ(180deg);
                    }
                }
                &.active{
                    height: auto;
                    .btns-nav{
                        img{
                            transform:rotateZ(0deg);
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                flex-wrap: wrap;
                .btn{
                    width: 8rem;
                    height: 3.6rem;
                    border-radius: 1.8rem;
                    margin-top: 1rem;
                    background-color: #eee;
                    font-size: 1.3rem;
                    font-weight: 400;
                    color: #333;
                    line-height: 3.6rem;
                    text-align: center;
                    &:not(:nth-of-type(3n)){
                        margin-right:0.5rem;
                    }
                    &.active{
                        background-color: #108B30;
                        color: #fff;
                        font-size: 1.4rem;
                        font-weight: 500;
                    }
                }
            }
        }
    }
</style>